<template>
  <FooterBase />
</template>
<script setup>
import FooterBase from "./FooterBase.vue";
</script>
